import { StepSelectControlProps } from 'app/components/StepSelectControl/StepSelectControl.interface';
import { Dictionary, DictionaryEntry } from 'app/services/dict.service';
import { AnswerGroup } from 'app/shared/interfaces/AnswerGroup.interface';

export const groupByOptionGroup: StepSelectControlProps['groupBy'] = (
  option
) => {
  return option.group || '';
};

export const getGroupedOptions = (
  answerGroups: Array<AnswerGroup>,
  options: Dictionary
) => {
  const getItemWithGroupLabel = (option: DictionaryEntry) => {
    const optionGroup = answerGroups!.find(
      (group) => group.groupName === option.group
    );

    const groupLabel = optionGroup?.label || '';

    return {
      ...option,
      group: groupLabel,
    };
  };

  return options.map(getItemWithGroupLabel);
};
